import React from 'react';
import '../styles/Services.css';
import { 
  FaHome, 
  FaHammer, 
  FaTree, 
  FaWarehouse,
  FaTruck,
  FaLayerGroup,
  FaCubes,
  FaLeaf,
  FaBorderAll,
  FaWind
} from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaLayerGroup />,
      title: 'Masonry',
      description: 'Professional masonry work with attention to detail and structural integrity.'
    },
    {
      icon: <FaHome />,
      title: 'Concrete',
      description: 'High-quality concrete services for foundations, driveways, and more.'
    },
    {
      icon: <FaCubes />,
      title: 'Stone Work',
      description: 'Beautiful stone installations that enhance your property\'s aesthetic appeal.'
    },
    {
      icon: <FaWarehouse />,
      title: 'Brick',
      description: 'Expert brick laying and repair services for lasting durability.'
    },
    {
      icon: <FaBorderAll />,
      title: 'Block',
      description: 'Precision block work for walls, structures, and foundations.'
    },
    {
      icon: <FaLeaf />,
      title: 'Landscaping',
      description: 'Transform your outdoor space with professional landscaping services.'
    },
    {
      icon: <FaTree />,
      title: 'Tree Services',
      description: 'Complete tree care including trimming, removal, and maintenance.'
    },
    {
      icon: <FaHammer />,
      title: 'Fence',
      description: 'Quality fence installation and repair for security and privacy.'
    },
    {
      icon: <FaTruck />,
      title: 'Junk Removal',
      description: 'Efficient junk removal services to keep your property clean.'
    },
    {
      icon: <FaWind />,
      title: 'Custom Blower Beds',
      description: 'Specialized custom blower bed installations for your unique needs.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive construction solutions for all your needs
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{animationDelay: `${index * 0.1}s`}}>
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-hover-effect"></div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <p className="cta-text">Ready to start your project?</p>
          <a href="tel:512-648-9102" className="btn btn-primary">
            Get Your Free Estimate Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;